import type { ToastMessageOptions } from 'primevue/toast';
import type { ToastServiceMethods } from 'primevue/toastservice';
import { useToastStore } from '@/stores/toasts.store';

const DEFAULT_TOAST_LIFE = 3000;

export const toastInfo = (toast: ToastServiceMethods, options: { summary: string; detail: string; life?: number }) => {
  toast.add({
    severity: 'info',
    summary: options.summary,
    detail: options.detail,
    life: options.life ?? DEFAULT_TOAST_LIFE
  });
};

export const toastSuccess = (toast: ToastServiceMethods, options: { summary: string; detail: string; life?: number }) => {
  toast.add({
    severity: 'success',
    summary: options.summary,
    detail: options.detail,
    life: options.life ?? DEFAULT_TOAST_LIFE
  });
};

export const toastError = async (toast: ToastServiceMethods, options: { summary: string; detail: string; life?: number }) => {
  const toastStore = useToastStore();

  const hash = hashCode(`${options.summary}${options.detail}`);
  const message: ToastMessageOptions = {
    severity: 'error',
    summary: options.summary,
    detail: options.detail,
    life: options.life ?? 0
  };

  if (toastStore.hasToast(hash)) {
    const toastToRemove = toastStore.getToast(hash)!;
    toast.remove(toastToRemove);
  }

  toastStore.addToast(hash, message);
  toast.add(message);
};

export const toastWarn = (toast: ToastServiceMethods, options: { summary?: string; detail?: string; life?: number }) => {
  toast.add({
    severity: 'warn',
    summary: options.summary,
    detail: options.detail,
    life: options.life ?? 0
  });
};

export const hashCode = (str: string): number => {
  let hash = 0,
    i: number,
    chr: number;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};